/**
 * popup-success-state.js
 * 1. AJAX newsletter form submission — no page reload
 * 2. Copy-to-clipboard for discount code button
 */
(function () {
  'use strict';

  // ── AJAX FORM SUBMISSION ──────────────────────────────────────────────────

  function initPopupForms() {
    document.querySelectorAll('.popup__newsletter').forEach(function (form) {
      if (form.dataset.ajaxBound) return;
      form.dataset.ajaxBound = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var submitBtn = form.querySelector('[type="submit"]');
        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value.trim() : '';

        if (!email) return;

        // Show loading state on button
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.dataset.originalText = submitBtn.querySelector('span')
            ? submitBtn.querySelector('span').textContent
            : submitBtn.textContent;
          var span = submitBtn.querySelector('span');
          if (span) span.textContent = '...';
          else submitBtn.textContent = '...';
        }

        // Build form data — Shopify customer form needs form_type + utf8
        var formData = new FormData(form);

        fetch('/contact#' + form.id, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then(function (response) {
            if (response.ok) {
              showSuccessState(form);
            } else {
              // Non-2xx — fall back to standard submit
              form.removeEventListener('submit', arguments.callee);
              form.submit();
            }
          })
          .catch(function () {
            // Network error — fall back to standard submit
            form.dataset.ajaxBound = '';
            form.submit();
          });
      });
    });
  }

  function showSuccessState(form) {
    var popup = form.closest('.popup');
    if (!popup) return;

    // Hide ALL pre-submission content: accent, headings, text, form, dismiss link, footer
    var preSubmitSelectors = [
      '.popup__desktop-accent',
      '.popup__mobile-accent',
      '.popup__desktop-heading',
      '.popup__mobile-heading',
      '.popup__subheading',
      '.popup__desktop-text',
      '.popup__mobile-text',
      '.popup__newsletter',       // the form itself
      '.popup__dismiss-text',     // "No thanks" link
      '.popup__footer-text',      // pre-submission footer
      '.popup__social',
    ];

    preSubmitSelectors.forEach(function (sel) {
      popup.querySelectorAll(sel).forEach(function (el) {
        el.style.display = 'none';
      });
    });

    // Find or build the success state element
    var successEl = popup.querySelector('.popup__success-state');

    if (successEl) {
      // Success state was pre-rendered in Liquid but hidden because
      // form hadn't been submitted yet — just show it
      successEl.style.display = '';
      successEl.removeAttribute('hidden');
    } else {
      // No success block configured — show a plain fallback message
      var textContainer = popup.querySelector('.popup__text-container');
      if (textContainer) {
        var fallback = document.createElement('div');
        fallback.className = 'popup__success-state';
        fallback.innerHTML = '<p style="margin:0;">Thanks for subscribing!</p>';
        textContainer.appendChild(fallback);
      }
    }

    // Re-init copy buttons in case they're now in the DOM
    initCopyButtons();
  }

  // ── COPY TO CLIPBOARD ─────────────────────────────────────────────────────

  function initCopyButtons() {
    document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
      if (btn.dataset.copyBound) return;
      btn.dataset.copyBound = 'true';

      btn.addEventListener('click', function () {
        var code = btn.dataset.copyCode;
        var copyLabel = btn.dataset.copyLabel || 'Copy code';
        var copiedLabel = btn.dataset.copiedLabel || 'Copied!';
        if (!code) return;

        // Select input for visual feedback
        var row = btn.closest('.popup__discount-code-row');
        if (row) {
          var input = row.querySelector('.popup__discount-code-input');
          if (input) input.select();
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code)
            .then(function () { showCopied(btn, copiedLabel, copyLabel); })
            .catch(function () { fallbackCopy(code, btn, copiedLabel, copyLabel); });
        } else {
          fallbackCopy(code, btn, copiedLabel, copyLabel);
        }
      });
    });
  }

  function showCopied(btn, copiedLabel, originalLabel) {
    btn.textContent = copiedLabel;
    btn.classList.add('is-copied');
    btn.disabled = true;
    setTimeout(function () {
      btn.textContent = originalLabel;
      btn.classList.remove('is-copied');
      btn.disabled = false;
    }, 2500);
  }

  function fallbackCopy(text, btn, copiedLabel, originalLabel) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try {
      document.execCommand('copy');
      showCopied(btn, copiedLabel, originalLabel);
    } catch (e) {
      console.warn('Copy failed', e);
    }
    document.body.removeChild(ta);
  }

  // ── INIT ──────────────────────────────────────────────────────────────────

  function init() {
    initPopupForms();
    initCopyButtons();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

})();
